<template>
  <div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-3">
            <li>
              <router-link to="/inventory/stockupload" class="">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
              </router-link>
            </li>
            <li>
              <h3>{{ $t("stockUpload.label.add.Add Stock Upload") }}</h3>
            </li>
          </ul>
        </div>
        <div class="vx-col w-full">
          <vx-card title no-shadow card-border>
            <div class="w-full">
              <div class="vx-row mb-4">
                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/6 xl:w-1/6">
                  <vs-radio
                    v-model="formStockUpload"
                    vs-value="individualLoad"
                    color="success"
                    class=""
                    @change="addStockerUploadRadio"
                    >{{ $t("stockUpload.label.add.Individual Load") }}</vs-radio
                  >
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/6 xl:w-1/6">
                  <vs-radio
                    v-model="formStockUpload"
                    color="success"
                    vs-value="bulkLoad"
                    @change="addStockerUploadRadio"
                    >{{ $t("stockUpload.label.add.Bulk Load") }}</vs-radio
                  >
                </div>
              </div>
            </div>
            <div class="vx-row" v-if="showFormindividualLoad">
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label font-semibold"
                    >{{ $t("stockUpload.label.add.GRN ID")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('stockUpload.label.add.GRN ID')"
                  >
                    <v-select
                      label="itemDescription"
                      v-model="item.inventoryGrnDatas"
                      :reduce="(obj) => obj.testId"
                      :options="items.inventoryGrnDatas"
                      :placeholder="$t('inventory.label.SelectItem')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full font-semibold"
                      @input="getGrnData(item.inventoryGrnDatas)"
                    >
                      <template v-slot:option="option"
                        >{{ option.testId }}--{{
                          option.itemDescription
                        }}</template
                      >
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
                <vs-input
                  :label="$t('stockUpload.label.add.Suplier Code')"
                  class="w-full mb-6 font-semibold"
                  v-model="item.supplierName"
                  disabled
                />
                <vs-input
                  :label="$t('inventory.label.business_entity_name')"
                  class="w-full mb-6 font-semibold"
                  v-model="item.officeName"
                  disabled
                />

                <div class="vx-row">
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div class="dropdown-with-label">
                      <small class="date-label font-semibold"
                        >{{ $t("stockUpload.label.add.Quality")
                        }}<span class="required"> *</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="quality"
                      >
                        <v-select
                          label="mCodeValue"
                          v-model="item.qualityDatas"
                          :reduce="(obj) => obj.mCodeValue"
                          :options="items.qualityDatas"
                          :placeholder="$t('inventory.label.SelectItem')"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="min-w-200 w-full font-semibold"
                        >
                          <template v-slot:option="option">{{
                            option.mCodeValue
                          }}</template>
                        </v-select>
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div class="dropdown-with-label">
                      <small class="date-label font-semibold">{{
                        $t("stockUpload.label.add.Item Model")
                      }}</small>
                      <v-select
                        label="model"
                        v-model="item.modelProvisionMappingData"
                        :reduce="(obj) => obj.id"
                        :options="items.modelProvisionMappingData"
                        :placeholder="$t('inventory.label.SelectModel')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full font-semibold"
                        @input="setItemModel(item.modelProvisionMappingData)"
                      >
                        <template v-slot:option="option">{{
                          option.model
                        }}</template>
                      </v-select>
                    </div>
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('stockUpload.label.add.Serial No')"
                    >
                      <vs-input
                        :label="$t('stockUpload.label.add.Serial No')"
                        class="w-full mb-2 font-semibold starlabel"
                        v-model="item.serialNumber"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('stockUpload.label.add.Provision No')"
                    >
                      <vs-input
                        :label="$t('stockUpload.label.add.Provision No')"
                        class="w-full mb-2 font-semibold starlabel"
                        v-model="item.provisioningSerialNumber"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <vs-input
                  :label="$t('stockUpload.label.add.Remarks')"
                  class="w-full mb-3 mt-2 font-semibold"
                  v-model="item.remarks"
                />
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <vs-input
                  :label="$t('stockUpload.label.add.itemDescription')"
                  class="w-full mb-5 font-semibold"
                  v-model="item.itemDescription"
                  disabled
                />
                <vs-input
                  :label="$t('stockUpload.label.add.Received Quantity')"
                  class="w-full mb-6 font-semibold"
                  v-model="item.receivedQuantity"
                  disabled
                />
                <vs-input
                  :label="$t('stockUpload.label.add.Ordered Quantity')"
                  class="w-full mb-6 font-semibold"
                  v-model="item.orderdQuantity"
                  disabled
                />
                <div class="vx-row">
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div class="dropdown-with-label">
                      <small class="date-label font-semibold">{{
                        $t("stockUpload.label.add.OEM Type")
                      }}</small>
                      <v-select
                        label="OEMType"
                        v-model="item.OEMType"
                        :options="OEMType"
                        :placeholder="$t('inventory.label.SelectItem')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full mb-3 font-semibold"
                      >
                        <template v-slot:option="option">{{
                          option.OEMType
                        }}</template>
                      </v-select>
                    </div>
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div class="dropdown-with-label">
                      <small class="date-label font-semibold">{{
                        $t("stockUpload.label.add.LM Type")
                      }}</small>
                      <v-select
                        label="lmType"
                        v-model="item.LmType"
                        :options="LmType"
                        :placeholder="$t('inventory.label.SelectItem')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full mb-3 font-semibold"
                      >
                        <template v-slot:option="option">{{
                          option.lmType
                        }}</template>
                      </v-select>
                    </div>
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <!-- <small class="date-label font-semibold">{{
                    $t("Is Paired")
                  }}</small> -->
                    <div class="vx-col w-full mb-6" style="margin: 1rem 0">
                      <vs-checkbox
                        class="mt-3 font-semibold"
                        v-model="item.isSelector"
                        @input="isPared"
                        >{{
                          $t("stockUpload.label.add.Is Paired")
                        }}</vs-checkbox
                      >
                    </div>
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div
                      class="dropdown-with-label"
                      style="margin: -0.65rem 0"
                      v-if="item.isSelector"
                    >
                      <small class="date-label font-semibold">{{
                        $t("stockUpload.label.add.Paired Item")
                      }}</small>
                      <v-select
                        label="itemCode"
                        :options="all"
                        v-model="item.pairedItemId"
                        :placeholder="$t('placeholder.label.SelectOne')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full mb-3"
                      >
                        <template v-slot:option="option">{{
                          option.itemCode
                        }}</template>
                      </v-select>
                    </div>
                  </div>
                </div>
                <vs-input
                  :label="$t('stockUpload.label.add.Carton No')"
                  class="w-full mb-3 font-semibold"
                  v-model="item.cartoonNumber"
                />
              </div>
            </div>
            <div class="vx-row" v-if="showFormBulkLoad">
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="selectDownloadSec">
                  <div class="dropdown-with-label">
                    <small class="date-label font-semibold"
                      >{{ $t("stockUpload.label.select_bulk_upload_type")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="name"
                    >
                      <v-select
                        label="name"
                        v-model="selectName"
                        :options="uploadName"
                        :reduce="(name) => name.name"
                        :placeholder="$t('placeholder.label.SelectOne')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full mb-2"
                      >
                        <template v-slot:option="option">{{
                          option.name
                        }}</template>
                      </v-select>
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                  <!-- <a href="/csv/Hardware Items.csv" download></a> -->
                  <div class="downloadFromHere text-center">
                    <img
                      src="@/assets/images/icons/download.svg"
                      :class="selectName ? 'cursor-pointer' : ''"
                      @click="downloadTemplate"
                    />
                    {{$t("inventory.label.Download_From_here")}}
                  </div>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <label class="form__container">
                  <div>
                    <img src="@/assets/images/icons/Upload.svg" />
                  </div>
                  <div v-if="!uploadedFileName">{{$t("inventory.label.Browse_file_to_Upload")}}</div>
                  <div style="color: #44bb44">
                    {{ uploadedFileName }}
                  </div>
                  <input
                    class="form__file"
                    type="file"
                    @change="uploadOnChange"
                  />
                </label>
                <span id="error"></span>
              </div>
              <div class="vx-col w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("stockUpload.label.add.Description")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('inventory.label.Description')"
                  >
                    <vs-textarea
                      :placeholder="$t('inventory.label.Description')"
                      v-model="UploadDescription"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
            </div>
          </vx-card>
          <div class="vx-row" v-if="showFormindividualLoad">
            <div class="vx-col w-full">
              <div class="saveCancelBtn marginB40">
                <vs-button
                  color="primary"
                  type="border"
                  class="mb-2"
                  @click="resetForm"
                  >{{ $t("inventory.label.Reset") }}
                </vs-button>
                <vs-button class="mr-3 mb-2" @click="createFeeMaster">{{
                  $t("inventory.label.Submit")
                }}</vs-button>
              </div>
            </div>
          </div>
          <div class="vx-row" v-if="showFormBulkLoad">
            <div class="vx-col w-full">
              <div class="saveCancelBtn mb-3">
                <vs-button
                  color="primary"
                  type="border"
                  class="mb-2"
                  @click="resetForm"
                  >{{ $t("inventory.label.Reset") }}
                </vs-button>
                <vs-button
                  class="mr-3 mb-2"
                  :disabled="!uploadedFileName"
                  @click="addBulkUploadFile"
                  >{{ $t("stockUpload.label.add.Upload & Process") }}</vs-button
                >
              </div>
            </div>
          </div>
          <vx-card title no-shadow card-border v-if="showFormBulkLoad">
            <vs-table
              :max-items="5"
              pagination
              :data="bulkUpload.pageItems"
              search
            >
              <template slot="header">
                <!-- ADD NEW -->
                <span class="vx-col order-1">
                  <!-- <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="bulkUploadsPopup = true"
                  size="small"
                >
                  {{ $t("link.uploadfile") }}</vs-button
                > -->
                </span>
              </template>
              <template slot="thead">
                <vs-th>{{ $t("stockUpload.label.add.Upload Process") }}</vs-th>
                <vs-th>{{
                  $t("stockUpload.label.add.Upload File Path")
                }}</vs-th>
                <vs-th>{{ $t("stockUpload.label.add.Process Date") }}</vs-th>
                <vs-th>{{
                  $t("stockUpload.label.add.Process/Total Records")
                }}</vs-th>
                <vs-th>{{ $t("inventory.label.status") }}</vs-th>
                <vs-th class="tHeadCenter">{{
                  $t("inventory.label.action")
                }}</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="index" v-for="(uploads, index) in data">
                  <vs-td :data="uploads.uploadProcess">{{
                    uploads.uploadProcess
                  }}</vs-td>
                  <vs-td :data="uploads.uploadFilePath">{{
                    uploads.uploadFilePath
                  }}</vs-td>
                  <vs-td :data="getDate(uploads.processDate)">{{
                    getDate(uploads.processDate)
                  }}</vs-td>
                  <vs-td
                    >{{ uploads.processRecords }}/{{
                      uploads.totalRecords
                    }}</vs-td
                  >
                  <vs-td :data="uploads.processStatus">{{
                    uploads.processStatus
                  }}</vs-td>
                  <vs-td class="whitespace-no-wrap">
                    <div class="container_img">
                      <feather-icon
                        :title="$t('inventory.label.Download_Log_File')"
                        icon="DownloadCloudIcon"
                        @click="downloadStatement(uploads.id)"
                        svgClasses="w-5 h-5 stroke-current text-cloud"
                        class="icon_row"
                      />
                      <feather-icon
                        :title="$t('inventory.label.Download_Uploaded_File')"
                        icon="DownloadIcon"
                        class="text-warning icon_row"
                        @click="
                          downloadFile(uploads.id, uploads.uploadFilePath)
                        "
                        svgClasses="w-5 h-5 stroke-current"
                      />
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import {
  itemDetailsTemplate,
  getByIdGood,
  isPared,
  postItem,
  getBySupplerdropdown,
  addBulkUploads,
  getBulkUploads,
} from "@/http/inventory";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import moment from "moment";
import { BUCKET_BASE_URL } from "@/http/index";
import { h } from "vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
const feeEmptyObj = {
  balanceQuantity: "",
  id: "",
  itemDescription: "",
  itemMasterId: "",
  itemcode: "",
  officeId: "",
  officeName: "",
  orderdQuantity: "",
  purchaseNo: "",
  receivedQuantity: "",
  supplierId: "",
  supplierName: "",
  units: "",
  itemModel: "",
  itemModelName: "",
  isSelector: false,
  inventoryGrnDatas: "",
  modelProvisionMappingData: "",
  LmType: "",
  all: "",
  OEMType: "",
  qualityDatas: "Good",
};

export default {
  data() {
    return {
      warningPopup: false,
      message: "",
      warningText: "",
      errorMessage: "",
      formStockUpload: "individualLoad",
      showFormindividualLoad: true,
      showFormBulkLoad: false,
      // isSelector: false,
      item: { ...feeEmptyObj },
      balanceQuantity: "",
      id: "",
      itemDescription: "",
      itemMasterId: "",
      itemcode: "",
      officeId: "",
      officeName: "",
      orderdQuantity: "",
      purchaseNo: "",
      receivedQuantity: "",
      supplierId: "",
      supplierName: "",
      units: "",
      qualityDatas: [],
      itemModel: "",
      uploadedFileName: null,
      inventoryGrnDatas: [],
      modelProvisionMappingData: [],
      statusDatas: [],
      itemMasterData: [],
      itemModelName: "",
      items: [],
      LmType: [
        "Gospell",
        "SMK - Skyrun",
        "l-box",
        "TRefonics",
        "SMSL",
        "DBC",
        "RLG / TVE",
      ],
      all: [],
      OEMType: ["Changhong", "Arion", "Skyworth", "jizhou"],
      addPopup: false,
      uploadName: [
        { name: "Hardware Items" },
        { name: "Adjustments" },
        { name: "Payments" },
        { name: "MRN" },
        { name: "Move Itemsale" },
        { name: "EPG" },
        { name: "Media Assets" },
        { name: "Office" },
        { name: "Simple Activation" },
        { name: "Add Plan" },
        { name: "Change Plan" },
        { name: "Cancel Plan" },
        { name: "ClientService Suspend" },
        { name: "ClientService Reactive" },
      ],
      UploadDescription: "",
      selectName: "",
      file: "",
    };
  },
  components: {
    Datepicker,
    ValidationObserver,
    ValidationProvider,
    "v-select": vSelect,
    h,
  },
  mounted() {
    this.itemDetailsTemplate();
    this.getDataUploads();
  },
  computed: {
    selectorDetails() {
      this.item.selectorDescription = this.selector;
    },
    bulkUpload() {
      return this.$store.getters["admin/getBulkUploads"];
    },
    ...mapState({
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    async setItemModel(id) {
      for (let itemModelData of this.modelProvisionMappingData) {
        if (itemModelData.id == id) {
          this.itemModelName = itemModelData.model;
          this.itemModel = id;
        }
      }
    },

    downloadStatement(id) {
      this.downloadFile2(
        BUCKET_BASE_URL +
          `/datauploads/printlog/${id}?tenantIdentifier=default`,
        `log${id}.xlsx`
      );
    },
    async downloadFile2(fullLink, name) {
      try {
        const bearerToken = sessionStorage.getItem("ngb:bearer_token") || null;
        const response = await fetch(fullLink, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        });
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", name);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading the statement:", error);
        this.$vs.notify({
          title: "Download Failed",
          text: "Unable to download the statement. Please try again.",
          color: "danger",
        });
      }
    },
    // downloadLog(id, path) {
    //   this.$store
    //     .dispatch("inventory/downloadLogFileAction", id)
    //     .then((response) => {
    //       const url = window.URL.createObjectURL(new Blob([response.data]));
    //       const link = document.createElement("a");
    //       link.href = url;
    //       link.setAttribute("download", "log-" + path.replace(/^.*[\\\/]/, ""));
    //       document.body.appendChild(link);
    //       link.click();
    //     })
    //     .catch(console.error);
    // },
    downloadTemplate() {
      if (!this.selectName) return;
      const link = document.createElement("a");
      link.href = "/csv/Hardware Items.csv";
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();
    },
    downloadFile(id, path) {
      this.$store
        .dispatch("inventory/downloadFileAction", id)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", path.replace(/^.*[\\\/]/, ""));
          document.body.appendChild(link);
          link.click();
        })
        .catch(console.error);
    },
    async getBySupplerdropdown() {
      try {
        const itemMasterData = await getBySupplerdropdown();
        this.master = itemMasterData.data;
      } catch (error) {
        console.log("something went wrong while retrieving fee by id", error);
      }
    },

    async itemDetailsTemplate() {
      try {
        const item = await itemDetailsTemplate();
        this.items = item.data;
        this.modelProvisionMappingData = this.items.modelProvisionMappingData;
      } catch (error) {
        console.log("something went wrong while retrieving fee by id", error);
      }
    },

    async getGrnData(id) {
      try {
        const data = await getByIdGood(id);
        this.grnData = data.data;
        this.itemMasterId = this.grnData.itemMasterId;
        this.itemcode = this.grnData.itemcode;
        this.item.itemDescription = data.data.itemDescription;
        this.item.officeName = data.data.officeName;
        this.item.receivedQuantity = data.data.receivedQuantity;
        this.item.supplierName = data.data.supplierName;
        this.item.orderdQuantity = data.data.orderdQuantity;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    async isPared() {
      try {
        const response = await isPared();
        this.all = response.data;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createFeeMaster() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      const postItemObj = {
        grnId: this.item.inventoryGrnDatas,
        isPairing: this.item.isSelector ? "Y" : "N",
        itemModel: this.itemModel,
        itemModelName: this.itemModelName,
        locale: "en",
        serialNumber: this.item.serialNumber,
        OemType: this.item.OEMType,
        LmType: this.item.LmType,
        quality: this.item.qualityDatas,
        provisioningSerialNumber: this.item.provisioningSerialNumber,
        status: "New",
        cartoonNumber: this.item.cartoonNumber,
        remarks: this.item.remarks,
        itemMasterId: this.itemMasterId,
        itemCode: this.itemcode,
        pairedItemId: this.item.pairedItemId && this.item.pairedItemId.id,
      };

      //-------------------------postItemObj.itemModel = desired format data ----------------------------------//
      try {
        const resp = await postItem(postItemObj);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Stock Upload Created Successfully!",
          type: "success",
        });
        if (resp.data.resourceId) {
          this.$router.push("/inventory/stockupload");
          this.resetForm();
        }
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
        console.log(
          "something went to wrong while creating createFeeMaster:",
          e
        );
      }
    },
    async addBulkUploadFile() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      let formData = new FormData();
      formData.append("status", this.selectName);
      formData.append("description", this.UploadDescription);
      formData.append("file", this.file);
      await addBulkUploads(formData)
        .then((response) => {
          this.getDataUploads();
          this.$router.push("/inventory/stockupload");
          this.resetForm();
          this.$swal({
            title: "Success",
            icon: "success",
            text: "Upload & Process Successfully!",
            type: "success",
          });
        })
        .catch((e) => {
          this.$swal({
            title: "Something went wrong!!",
            icon: "error",
            type: "error",
          });
        });
    },

    uploadOnChange(event) {
      this.file = event.target.files ? event.target.files[0] : null;
      if (this.file.type != "text/csv") {
        this.file = null;
        error.textContent = "This is not a csv file. Please put a csv file";
        error.style.color = "red";
        return;
      } else {
        error.textContent = "";
      }
      this.uploadedFileName = this.file.name;
    },
    getDate(dateArray) {
      const date = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
      const formattedDate = moment(date).format(this.formattedDate);
      return formattedDate;
    },
    async getDataUploads() {
      try {
        const response = await getBulkUploads();
        this.$store.dispatch("admin/setBulkUploads", response.data);
      } catch (error) {
        console.log(
          "something went to wrong while retrieving bulk Uploads:",
          error
        );
      }
    },
    resetForm() {
      this.item = { ...feeEmptyObj };
      this.item.inventoryGrnDatas = "";
      this.item.isSelector = "";
      this.itemModel = "";
      this.itemModelName = "";
      this.item.serialNumber = "";
      this.item.OEMType = "";
      this.item.LmType = "";
      this.item.qualityDatas = "Good";
      this.item.provisioningSerialNumber = "";
      this.item.cartoonNumber = "";
      this.item.remarks = "";
      this.itemMasterId = "";
      this.itemcode = "";
      this.item.supplierName = "";
      this.item.officeName = "";
      this.item.modelProvisionMappingData = "";
      this.item.itemDescription = "";
      this.item.receivedQuantity = "";
      this.item.orderdQuantity = "";
      this.selectName = "";
      this.UploadDescription = "";
      this.file = "";
      // this.$router.push("/inventory/stockupload");
    },
    created() {
      this.itemDetailsTemplate();
      this.createFeeMaster();
      this.id = this.$route.params.id;
      this.getDataUploads();
    },
    addStockerUploadRadio(e) {
      if (this.formStockUpload == "individualLoad") {
        this.showFormBulkLoad = false;
        this.showFormindividualLoad = true;
      } else {
        this.showFormindividualLoad = false;
        this.showFormBulkLoad = true;
      }
    },
  },
  watch: {
    selector(value) {
      let indx = this.selectorDetails.indexOf(value);
      this.item.selectorDescription = this.selectorDescription[indx];
    },
    selectD(value) {
      let indx = this.selectorDescription.indexOf(value);
      this.selector = this.selectorDetails[indx];
    },
  },
};
</script>
<style lang="scss" scoped>
.downloadFromHere img {
  margin: 0 auto;
  margin-bottom: 10px;
}
.downloadFromHere a {
  color: #000;
  text-transform: uppercase;
  font-weight: 600;
}
.selectDownloadSec {
  background: #f8f8f8;
  padding: 15px;
  border-radius: 12px;
}
.form__container {
  position: relative;
  width: 100%;
  height: 195px;
  border: 2px dashed #bbb5ff;
  display: block;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 18px;
  color: silver;
  margin-bottom: 5px;
  background: #e9e7ff;
  border-radius: 12px;
  border-color: #bbb5ff;
  padding: 50px 0;
}
.form__file {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  cursor: pointer;
  opacity: 0;
}
.form__container img {
  margin: 0 auto;
  margin-bottom: 20px;
}
.marginB40 {
  margin-bottom: 40px;
}
</style>
